import { render, staticRenderFns } from "./EditableCard.vue?vue&type=template&id=5c936dac&"
import script from "./EditableCard.ts?vue&type=script&lang=ts&"
export * from "./EditableCard.ts?vue&type=script&lang=ts&"
import style0 from "./EditableCard.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports